var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { failure, initial, pending, success } from '@devexperts/remote-data-ts';
import Axios from 'axios';
import { asks } from 'fp-ts/lib/Reader';
import { from, Subject } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { isDefined } from './object.utils';
export var AxiosReader = asks(function (context) {
    var axios = Axios.create({
        baseURL: context.baseUrl,
        xsrfCookieName: '__XSRF-TOKEN_' + Math.random(),
    });
    axios.errors$ = new Subject();
    context.token$.subscribe(function (token) {
        axios.defaults.headers.common = token
            .map(function (token) { return ({ Authorization: "Bearer " + token }); })
            .getOrElse({});
    });
    axios.interceptors.response.use(undefined, function (error) {
        axios.errors$.next(error);
        return Promise.reject(error);
    });
    return axios;
});
export function toRemoteData(promise) {
    return from(promise.then(function (response) {
        return response ? success(response.data) : initial;
    }, function (error) {
        var apiError;
        if (error instanceof Error) {
            apiError = error;
            apiError.data = error.response ? error.response.data : undefined;
        }
        else {
            apiError = new Error('' + error);
        }
        return failure(apiError);
    })).pipe(startWith(pending));
}
/**
 * credits: https://stackoverflow.com/q/12168909
 */
export function dataUrlToBlob(url) {
    var parts = url.split(',');
    var byteString = atob(parts[1]);
    var mimeString = parts[0].split(':')[1].split(';')[0];
    var buffer = new ArrayBuffer(byteString.length);
    var bytes = new Uint8Array(buffer);
    for (var i = 0; i < byteString.length; i++) {
        bytes[i] = byteString.charCodeAt(i);
    }
    return new Blob([buffer], { type: mimeString });
}
export var unauthorizeAxiosRequest = function (data, headers) {
    delete headers.common.Authorization;
    return data;
};
export var sendJson = function (data, headers) {
    headers['Content-Type'] = 'application/json';
    return JSON.stringify(data);
};
export function readFiles(files) {
    if (files.length === 0) {
        return Promise.resolve([]);
    }
    return new Promise(function (resolve) {
        var result = [];
        var filesHandled = 0;
        function acceptResult() {
            filesHandled++;
            if (filesHandled >= files.length) {
                resolve(result);
            }
        }
        files.map(function (file) {
            var reader = new FileReader();
            reader.onabort = acceptResult;
            reader.onerror = acceptResult;
            reader.onload = function () {
                var data = reader.result;
                result.push({ data: data, name: file.name });
                acceptResult();
            };
            reader.readAsDataURL(file);
        });
    });
}
export function readFilesOrData(files) {
    var toResolve = files
        .filter(function (f) { return !f.fileData; })
        .map(function (f) { return f.file; })
        .filter(isDefined);
    return readFiles(toResolve).then(function (resolved) { return __spreadArray(__spreadArray([], resolved, true), files.map(function (f) { return f.fileData; }).filter(isDefined), true); });
}
export function isUnauthorized(rd) {
    return (rd.isFailure() &&
        rd.error &&
        typeof rd.error === 'object' &&
        'status' in rd.error &&
        rd.error.status === 401);
}
//# sourceMappingURL=axios.js.map